 
export enum AuditLogType {
  Unknown = 0,
  Alert = 1,
  EpcScan = 2,
  User = 3,
  Tenant = 4,
  ClearList = 5,
  RegisterDevice = 6,
  OptelTermsOfUse = 7,
  NmvsTermsOfUse = 8,
  TermsOfUseAcceptance = 9,
  UnregisterDevice = 10,
  ManualEntry = 11
}


// WEBPACK FOOTER //
// ./src/types/audit-log-type.ts